export { default as AppDetails } from "./appDetails";
export { default as AppDetailsSkeleton } from "./appDetailsSkeleton";
